import { render, staticRenderFns } from "./akl.vue?vue&type=template&id=cd1e1224&scoped=true"
import script from "./akl.vue?vue&type=script&lang=js"
export * from "./akl.vue?vue&type=script&lang=js"
import style0 from "./akl.vue?vue&type=style&index=0&id=cd1e1224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1e1224",
  null
  
)

export default component.exports